module.exports = __webpack_public_path__ + "advanced3.png?0599ff0f41c6af48ec7daab41bde8824";